import type { OrganizationRole } from "../model/OrganizationRole";
import API, { responseOf } from "./base";

export const list = (): Promise<OrganizationRole[]> =>
  responseOf(API.get("/organization-roles/list"));

export const get = (organizationRoleId: string): Promise<OrganizationRole> =>
  responseOf(API.get(`/organization-roles/${organizationRoleId}`));

export const byOrganization = (
  organizationId: string,
): Promise<OrganizationRole[]> =>
  responseOf(API.get(`/organization-roles/byOrganization/${organizationId}`));

export const assignToOrganization = async (
  organizationRoleId: string,
  organizationId: string,
): Promise<void> => {
  await API.post(
    `/organization-roles/${organizationRoleId}/assignToOrganization/${organizationId}`,
  );
};

export const unassignToOrganization = async (
  organizationRoleId: string,
  organizationId: string,
): Promise<void> => {
  await API.post(
    `/organization-roles/${organizationRoleId}/unassignToOrganization/${organizationId}`,
  );
};
